export interface EmpiricalRule {
  empiricalRuleId: number
  fraudDataId: number
  ruleId: number
  ruleDescription: string
  result: boolean
  isActive: boolean
}


export interface EmpiricalRuleClaimResponse {
  sortOrder?: number
  ruleName?: string
  ruleDescription?: string
  operatorValue?: string
  thresholdValue?: string
  hasPassed: boolean
  result?: string
};

export interface EmpiricalRuleResponse {
  fieldName?: string
  description?: string
  isActive: boolean
};